type UseGetProductName = () => string;
export const useGetProductName: UseGetProductName = () => 'Viva Engage';
